import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import EN from './en.json';
import FR from './fr.json';
import AR from './ar.json';

const  locale  = localStorage.getItem("locale");

i18n
  .use(initReactI18next)

  .init({
    resources: {
      en: { translation: EN },
      fr: { translation: FR },
      ar: { translation: AR },
    },
    lng: locale !== null ? JSON.parse(locale) : "fr", 
    debug: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;